;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('VulnRequestCtrl', VulnRequestCtrl)

  function VulnRequestCtrl(
    $scope,
    $controller,
    $routeParams,
    vulnRequestService,
    appTracesApiConfig,
    traceRenderService,
    ORG_VULN_EVENTS
  ) {
    'ngInject'

    this.$onInit = function () {
      angular.extend($scope, {
        showRequest: showRequest
      })
      init()
    }

    function init() {
      var baseCtrl = $controller('BaseVulnRequestCtrl', { $scope: $scope })
      baseCtrl.$onInit()
      traceRenderService.getHttpRequest($scope, $scope.getTraceUuid())
      _emitTraceActiveEvent()
    }

    function _emitTraceActiveEvent() {
      var eventName = ORG_VULN_EVENTS.ORG_TRACE_ACTIVE
      if ($routeParams.serverId) {
        eventName = ORG_VULN_EVENTS.SERVER_TRACE_ACTIVE
      } else if ($routeParams.appId) {
        eventName = ORG_VULN_EVENTS.APP_TRACE_ACTIVE
      }
      $scope.$emit(eventName, { active: 'request' })
    }

    function showRequest() {
      vulnRequestService.showRequest({
        resolve: {
          httpRequest: function () {
            return appTracesApiConfig.getHttpRequestDetails(
              $scope.getTraceUuid()
            )
          }
        }
      })
    }
  }
})()
